import * as React from 'react';

const ProjectBannerLogoIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
    props
) => (
    <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="white" />
        <g clipPath="url(#clip0_14149_94416)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M31.0668 28.0459C30.0564 25.9206 29.0472 23.7958 28.0387 21.6729C28.0233 21.6379 27.9975 21.5967 27.955 21.5727C27.9126 21.5487 27.8652 21.5425 27.8093 21.5425H24.3051C26.2608 19.729 27.5085 17.1633 27.5885 14.3055C27.5928 14.145 27.4624 14.0134 27.3013 14.0134H24.3937C24.3937 18.0341 21.1343 21.2941 17.113 21.2941H16.1985C17.3301 18.9098 18.4598 16.5256 19.5883 14.1401C19.6036 14.1026 19.6276 14.0632 19.6707 14.0398C19.7137 14.0165 19.7598 14.014 19.8176 14.014H24.4023L24.398 14.0029L22.7523 11V11.0012H16.6954C16.6542 11.0012 16.6173 11.0043 16.5847 11.0215C16.5521 11.0394 16.5331 11.0683 16.5208 11.0966C14.7884 14.7495 13.0541 18.4074 11.3187 22.0702C10.3741 24.0615 9.43007 26.0534 8.48547 28.0459C8.47378 28.0681 8.46517 28.0914 8.45533 28.1166C8.4498 28.1314 8.44365 28.1468 8.4375 28.1628H12.8297C12.8647 28.1658 12.9004 28.1579 12.9293 28.1419C12.9582 28.1253 12.9785 28.1007 12.9859 28.073C13.5676 26.8412 14.1476 25.6149 14.7263 24.3936C14.7416 24.3598 14.7644 24.3247 14.8037 24.3038C14.8431 24.2829 14.8775 24.2817 14.9372 24.2817H24.6182C24.6784 24.2817 24.7086 24.2841 24.7467 24.3038C24.7848 24.3241 24.8057 24.3555 24.8223 24.3893C25.4022 25.61 25.9803 26.8313 26.5559 28.0521C26.5676 28.0761 26.5885 28.113 26.6224 28.132C26.6562 28.1511 26.6863 28.1535 26.7392 28.1548H31.1148L31.0668 28.0447V28.0459Z"
                fill="white"
            />
        </g>
        <defs>
            <clipPath id="clip0_14149_94416">
                <rect
                    width="22.6779"
                    height="17.1634"
                    fill="white"
                    transform="translate(8.4375 11)"
                />
            </clipPath>
        </defs>
    </svg>
);

export default ProjectBannerLogoIcon;
